import React from 'react';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import BaseForm from '../../../../components/form/BaseForm';
import Input from '../../../../components/input/Input/Input';
import Select from '../../../../components/input/Select/Select';
import SearchBox from '../../../../components/outline/SearchBox';
import { TAG_STATUS_SELECT_LIST } from '../../../../constants/service/app/tagConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { TAG_LIST_SEARCH_DATA_MODEL, TAG_LIST_SEARCH_OPTION_MODEL } from '../../../../store/modules/tag/models';
import './TagListSearchBox.scss';

const TagListSearchBox = (props) => {
  const { setData, tagGroupSelectList, searchData, getList } = props;
  const { tagStatus, tagName, tagGroupIdList, createDate } = searchData;

  return (
    <SearchBox
      className="tag-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: TAG_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
          isInit: true,
        });
        setData({
          path: [],
          value: TAG_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*태그 상태*/}
      <BaseForm
        label="태그 상태"
        content={
          <Select
            className="tag-status-select"
            list={TAG_STATUS_SELECT_LIST}
            onChange={(value) =>
              setData({
                path: ['tagStatus'],
                value,
              })
            }
            defaultValue={tagStatus}
            value={tagStatus}
            isTable={false}
          />
        }
      />

      {/*태그명 검색*/}
      <BaseForm
        label="태그명"
        content={
          <Input
            value={tagName}
            onChange={(value) =>
              setData({
                path: ['tagName'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={30}
            size="large"
          />
        }
      />

      {/*태그 그룹 검색*/}
      <BaseForm
        label="태그 그룹"
        content={
          <Select
            className="tag-group-id-list-select"
            list={tagGroupSelectList}
            onChange={(value) =>
              setData({
                path: ['tagGroupIdList'],
                value,
              })
            }
            mode="multiple"
            defaultValue={tagGroupIdList}
            value={tagGroupIdList}
            isTable={false}
          />
        }
      />

      {/*태그 생성일*/}
      <BaseForm
        label="태그 생성일"
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default TagListSearchBox;
